{
  "article.backHeader.label": "Takaisin",
  "common.appName": "Oma+",
  "common.brandFullName": "YTK Työelämä",
  "common.loading": "Ladataan…",
  "common.notFound.body": "Etsimääsi sivua ei ole olemassa tai se on poistettu.",
  "common.notFound.heading": "Sivua ei löytynyt.",
  "content.unavailable.backHome": "Palaa etusivulle",
  "content.unavailable.body": "Sisältöpalvelu on tilapäisesti pois käytöstä. Yritä myöhemmin uudelleen tai palaa etusivulle.",
  "content.unavailable.heading": "Sisältö ei ole nyt saatavilla.",
  "content.hero.videoLabel": "Video",
  "routes.lakiruutu.title": "Lakiruutu",
  "routes.lakiruutu.empty": "Ei videoita saatavilla.",
  "routes.lakiruutu.showMore": "Katso lisää tietoja",
  "routes.lakiruutu.playNewTab": "Toista video (avautuu uuteen välilehteen)"
}
